import React from 'react'
import { Route, Switch } from 'react-router-dom'

import {
  AccessPageContainer,
  AccessHistoryPageContainer,
  MyUnitsPageContainer,
  SettingsPageContainer,
  SupportPageContainer,
} from './index'

export const SettingsRouter: React.FC = React.memo(() => {
  return (
    <Switch>
      <Route component={MyUnitsPageContainer} path="/settings/homes" />
      <Route component={SupportPageContainer} path="/settings/support" />
      <Route
        component={AccessHistoryPageContainer}
        path="/settings/access/log"
      />
      <Route component={AccessPageContainer} path="/settings/access" />
      <Route component={SettingsPageContainer} path="/settings" />
    </Switch>
  )
})
